import { Flex, FlexProps, Image, Text } from '@chakra-ui/react';

import fullLogoBlack from 'app/assets/svg/fullLogoBlack.svg';
import fullLogoWhite from 'app/assets/svg/fullLogoWhite.svg';

import { companyLogoFor, useCompanyBranding } from 'app/contexts/Branding';

interface PoweredByAslanProps extends FlexProps {
  /** Which ground the credit sits on: dark grounds take white text and the white logo. */
  variant?: 'onLight' | 'onDark';
}

const STYLE = {
  onLight: { color: 'brand.darkPurple', logo: fullLogoBlack },
  onDark: { color: 'brand.white', logo: fullLogoWhite },
};

/**
 * Credits Aslan under a company's own logo on the same ground. With no company logo showing,
 * the Aslan logo is already there, so the credit would only repeat it.
 */
function PoweredByAslan({ variant = 'onLight', ...flexProps }: PoweredByAslanProps) {
  const branding = useCompanyBranding();

  if (branding.isBranded && companyLogoFor(branding, variant)) {
    const { color, logo } = STYLE[variant];

    return (
      <Flex align="center" gap="6px" data-testid="powered-by-aslan" {...flexProps}>
        <Text fontSize="xs" color={color}>
          Powered by
        </Text>
        <Image src={logo} alt="Aslan" w="48px" />
      </Flex>
    );
  }

  return null;
}

export default PoweredByAslan;
